export default {
  data: function() {
    return {
      fields: {}
    }
  },
  computed: {
    invalidFields() {
      return Object.keys(this.fields).filter(key => !this.fields[key].valid)
    }
  },
  methods: {
    registerField(name, component) {
      if (this.fields[name]) {
        this.fields[name].components.push(component)
        return;
      }
      console.debug('field %s registered', name);
      this.createField(name, {components: [component], value: component.fieldValue});
    },
    deregisterField(name, component) {
      if (this.fields[name]) {
        let index = this.fields[name].components.indexOf(component);
        if (index !== -1) {
          console.debug('field %s deregistered', name);
          this.fields[name].components.splice(index, 1);
        }
      }
    },
    setValue(name, value) {
      if (this.fields[name]) {
        this.fields[name].value = value;
        this.fields[name].components.forEach(vm => {
          vm.setValue(value);
        });
      } else {
        this.createField(name, {value: value})
      }
    },
    createField(name, defaultOptions) {
      this.$set(this.fields, name, {
        name: name,
        value: null,
        components: [],
        valid: true,
        ...defaultOptions
      });
    },
    getValue(name) {
      return this.fields[name] && this.fields[name].value ? this.fields[name].value : null;
    },
    collectFormData() {
      const formData = {};
      Object.keys(this.fields).forEach(key => {
        formData[key] = this.fields[key].value;
      });
      return formData;
    },
    validateActiveFields() {
      const context = {formData: this.collectFormData()};
      let totalValid = true;
      Object.keys(this.fields).forEach(key => {
        if (this.fields[key].components.length) {
          let valid = true;
          this.fields[key].components.forEach(vm => {
            valid = valid && vm.validate(context);
          });
          this.fields[key].valid = valid;
          if (!valid) console.debug('validation failed for field', key);
          totalValid = totalValid && valid;
        }
      });

      return totalValid;
    }
  }
}
